import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 12,
  },
  line: {
    flex: 1,
    height: 1,
    background: 'rgba(0,0,0,0.07)',
  },
  accent: {
    width: 3,
    height: 16,
    background: 'linear-gradient(180deg, #3b82f6, #6366f1)',
    borderRadius: 2,
    flexShrink: 0,
  },
  label: {
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    fontSize: '0.65rem',
    color: '#64748b',
    flexShrink: 0,
  },
}));

function SectionTitle({ children, icon: Icon }) {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <div className={classes.accent} />
      {Icon && <Icon style={{ fontSize: 14, color: '#3b82f6', flexShrink: 0 }} />}
      <Typography className={classes.label}>{children}</Typography>
      <div className={classes.line} />
    </Box>
  );
}

export default SectionTitle;
